import {
  SET_PROCESSED_NOTES,
  ADD_PROCESSED_NOTE,
  REMOVE_PROCESSED_NOTE,
  DELETE__NOTE_FILE,
  RESET_PROCESSED_NOTES,
  RESET_PROCESSED_NOTES_UNLESS_PENDING,
  EXTRACT_URL_START,
  EXTRACT_URL_SUCCESS,
  EXTRACT_URL_FAILURE,
  SET_FOLDER_TITLE,
  SET_TARGET_FOLDER
} from '../../actions/types';

import { matchFileName } from '../../../context/uploadNotes/matchFileName';

// Handler per l'azione SET_PROCESSED_NOTES
export const handleSetProcessedNotes = (state, payload) => {
  return {
    ...state,
    processedNotes: [...state.processedNotes, payload],
  };
};

// Handler per l'azione ADD_PROCESSED_NOTE
export const handleAddProcessedNote = (state, payload) => {
  return {
    ...state,
    processedNotes: [...state.processedNotes, payload],
  };
};

// Handler per l'azione REMOVE_PROCESSED_NOTE
export const handleRemoveProcessedNote = (state, payload) => {
  return {
    ...state,
    processedNotes: state.processedNotes.filter(note => {
      // Per documenti estratti da URL, confronta con source_url
      if (note.type === 'url-extract' && note.source_url) {
        return note.source_url !== payload;
      }
      // Per altri documenti, confronta con id
      return note.id !== payload;
    }),
  };
};

// Handler per l'azione DELETE__NOTE_FILE
export const handleDeleteNoteFile = (state, payload) => {
  const copyArray = [...state.processedNotes];
  
  // search file by name and delete it
  const indexFile = copyArray.findIndex(note => matchFileName(note.name, payload));
  
  // if file not found, return state
  if (indexFile === -1) return state;
  copyArray.splice(indexFile, 1);
  
  return { ...state, processedNotes: [...copyArray] };
};

// Handler per l'azione RESET_PROCESSED_NOTES
export const handleResetProcessedNotes = (state) => {
  // Mantieni la data d'esame persistita (se presente) per non perdere l'accesso all'Agenda
  let persistedExamDate = '';
  try {
    persistedExamDate = localStorage.getItem('examDate') || state.examDate || '';
  } catch (e) {
    persistedExamDate = state.examDate || '';
  }

  return {
    ...state,
    processedNotes: [],
    // Reset anche degli altri stati correlati alla preview
    documentsQA: [],
    hasPreview: false,
    isSubmitting: false,
    loadingMessage: null,
    extractedQA: [],
    flashcardsQA: [],
    quizQA: [],
    summary: null,
    isGenerate: false,
    generatedDocument: null,
    customInstructions: '', // Reset anche le istruzioni personalizzate
    selectedMateria: '', // Reset della materia selezionata (Maturità)
    showMateriaWarning: false, // Reset warning materia
    studyMode: null, // Reset della modalità di studio
    // Non perdere l'esame: reidrata dal localStorage (fallback al valore corrente)
    examDate: persistedExamDate,
    folderTitle: '', // Reset del titolo cartella
    targetFolderId: null // Reset della cartella di destinazione (Home V2)
  };
};

// Handler per l'azione RESET_PROCESSED_NOTES_UNLESS_PENDING (STU-362)
//
// Lo manda la Home al mount. Prima mandava RESET_PROCESSED_NOTES senza
// condizioni: chi sceglieva un file, andava a cercarlo in Materiale e tornava
// trovava la card vuota, e nessun evento lo raccontava (Martina, 11/09/2026:
// tre scelte perse e una disdetta; giorgiagloria16, 14/09, tre file scelti e
// poi riscelti). La regola: se ci sono file in attesa e «Genera» non e' stato
// premuto, non si tocca niente. `isProcessing` lo alzano solo i percorsi che
// hanno gia' creato il documento (Genera, URL, file grande) prima di portare
// la persona su Ripeti: se e' alto, la coda e' stata consumata e la Home
// riparte pulita come ha sempre fatto.
export const handleResetProcessedNotesUnlessPending = (state) => {
  const inAttesa = Array.isArray(state.processedNotes) && state.processedNotes.length > 0;
  if (inAttesa && !state.isProcessing) return state;
  return handleResetProcessedNotes(state);
};

// Handler per l'azione SET_FOLDER_TITLE
export const handleSetFolderTitle = (state, payload) => {
  return {
    ...state,
    folderTitle: payload || '',
  };
};

// Handler per l'azione EXTRACT_URL_START
export const handleExtractUrlStart = (state) => {
  return {
    ...state,
    isLoading: true,
    isGenerate: false,
  };
};

// Handler per l'azione EXTRACT_URL_SUCCESS
export const handleExtractUrlSuccess = (state) => {
  return {
    ...state,
    isLoading: false,
    isGenerate: true,
  };
};

// Handler per l'azione EXTRACT_URL_FAILURE
export const handleExtractUrlFailure = (state) => {
  return {
    ...state,
    isLoading: false,
    isGenerate: false,
  };
};

// Reducer per gestire le azioni relative alle note elaborate
const processedNotesReducer = (state, action) => {
  switch (action.type) {
    case SET_PROCESSED_NOTES:
      return handleSetProcessedNotes(state, action.payload);
    case ADD_PROCESSED_NOTE:
      return handleAddProcessedNote(state, action.payload);
    case REMOVE_PROCESSED_NOTE:
      return handleRemoveProcessedNote(state, action.payload);
    case DELETE__NOTE_FILE:
      return handleDeleteNoteFile(state, action.payload);
    case RESET_PROCESSED_NOTES:
      return handleResetProcessedNotes(state);
    case RESET_PROCESSED_NOTES_UNLESS_PENDING:
      return handleResetProcessedNotesUnlessPending(state);
    case EXTRACT_URL_START:
      return handleExtractUrlStart(state);
    case EXTRACT_URL_SUCCESS:
      return handleExtractUrlSuccess(state);
    case EXTRACT_URL_FAILURE:
      return handleExtractUrlFailure(state);
    case SET_FOLDER_TITLE:
      return handleSetFolderTitle(state, action.payload);
    case SET_TARGET_FOLDER:
      return { ...state, targetFolderId: action.payload || null };
    default:
      return null; // Indica che questa azione non è gestita da questo reducer
  }
};

export default processedNotesReducer; 
